import { tv, VariantProps } from '@workspace/lib';

export const typographyVariants = tv({
  variants: {
    variant: {
      h1: 'font-heading font-bold text-4xl md:text-6xl leading-12 md:leading-19.5',
      h2: 'font-heading font-bold text-[28px] md:text-5xl leading-9 md:leading-15',
      h3: 'font-heading font-bold text-2xl md:text-4xl leading-7.5 md:leading-12',
      h4: 'font-heading font-bold text-2xl md:text-[28px] leading-7.5 md:leading-9',
      h5: 'font-heading font-semibold text-lg md:text-2xl leading-6 md:leading-7.5',
      h6: 'font-heading font-bold text-lg md:text-lg leading-6',
      bodyLg: 'font-body font-normal text-xl md:text-xl leading-6 md:leading-8',
      bodyMd: 'font-body font-normal text-base md:text-base leading-5 md:leading-6',
      bodySm: 'font-body font-normal text-sm md:text-sm leading-4  md:leading-5',
      bodyXs: 'font-body font-normal text-xs md:text-xs leading-4',
      bodyTiny: 'font-body font-normal text-tiny leading-3',
      link: 'font-body font-semibold text-sm underline cursor-pointer',
      button: 'font-body font-semibold text-base',
      hyperlinkVisited: 'font-body font-semibold text-sm underline cursor-pointer',
    },
    tone: {
      default: 'text-secondary-400',
      link: 'text-primary',
      linkVisited: 'text-primary-500',
    },
    loading: {
      true: 'animate-pulse bg-secondary-50 text-transparent rounded-md',
      false: '',
    },
  },
  defaultVariants: { tone: 'default', loading: false },
});

export type TypeographyVariants = VariantProps<typeof typographyVariants>;
